import script from "./UserAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAddress.vue?vue&type=script&setup=true&lang=ts"

import "./UserAddress.vue?vue&type=style&index=0&id=2b413440&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b413440"]])

export default __exports__